import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isNil, isEmpty } from 'lodash';
import locale from 'antd/lib/date-picker/locale/el_GR';
import {
  Select,
  DatePicker,
  Row,
  Col,
  Table,
  Divider,
  Space,
  Tooltip,
  Spin,
  AutoComplete,
  Input,
  Modal,
} from 'antd';
import { ReactComponent as SearchIcon } from '../../../assets/icons/search_icon.gov.svg';
import { ReactComponent as ArrowIcon } from '../../../assets/icons/dropdown-arrow.svg';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/calendar.gov.svg';
import {
  clearSayt,
  fetchProcessSAYT,
  fetchProcInstancesDetailed,
  getAllTaskNames,
  cancelProcessInstance,
} from 'store/appTrack/actions';
import { ReactComponent as ActionsIcon } from '../../../assets/icons/more_dots.svg';
import { ReactComponent as FilterIcon } from '../../../assets/icons/filter_lines.svg';
import { ReactComponent as FilterIconBold } from '../../../assets/icons/filter_lines_bold.svg';
import Popover from '@mui/material/Popover';
import ActionList from './components/ActionList';
import TableCell from './components/TableCell';
import moment from 'moment';
import { StatusTag } from 'components';
import { committeeOutcomes, companyLegalTypeList, handleCommitteeSubmit, isBeneficiary, schoolGrades } from 'utils';
import { getLocalString, localNames } from 'utils/localisation.service';
import { useNavigate } from 'react-router-dom';
import NoResults from './components/NoResults';
import { getSystemLocales, clearForm } from 'store/forms/actions';
import { setActiveFormId } from 'store/activeForm/actions';
import { checkUser, getUser, getTaxisData } from 'store/user/actions';
import { ReactComponent as CancelWarningIcon } from '../../../assets/icons/cancel_warning_icon.svg';
import { getFullDateTimeWithSeconds, getFullDateTime } from 'utils/helpers';
import { kadArray } from 'utils/kadArray';
import { handleCheckUniqueness } from 'utils';
import { checkUniqueness, updateFormField } from 'store/forms/actions';
import { SubmitModal } from '../../../components/layout/components';
import { handleAuditorSubmit, auditorOutcomes } from '../../../utils';
import { Alert } from 'antd';

const AppTrackPage1 = ({ disabled }) => {
  const viewMode = false;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedProcId, setSelectedProcId] = useState();
  const [isFiltersVisible, setFiltersVisible] = useState(false);
  const [filterImg, setFilterImg] = useState(<FilterIcon />);
  const user = useSelector(state => state.user);
  const userStatus = useSelector(state => state.user.status);
  const [saytOptions, setSaytOptions] = useState([]);
  //const saytOptions = useSelector(state => state.appTrack.sayt);
  const [detailedPayload, setDetailedPayload] = useState({ parameterList: [] });
  const privileges = useSelector(state => state.user.privileges);
  const groups = useSelector(state => state.user.groups);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(Boolean(anchorEl));
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const results = useSelector(state => state.appTrack.variables);
  const resultSize = useSelector(state => state.appTrack.resultSize);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const locales = useSelector(state => state.forms?.localeStrings);
  const loadingPage = useSelector(state => state.appTrack.loadingApptrack);
  const [currentPage, setCurrentPage] = useState(1);
  const taskNames = useSelector(state => state.appTrack.taskNames);
  const sayt = useSelector(state => state.appTrack.sayt);
  const isKTP = user.groups?.map(item => item.name).includes('KTP');
  const [cancelModal, setCancelModal] = useState(false);
  const [pageSizeFlag, setPageSizeFlag] = useState(5);
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortdirection] = useState(undefined);

  const loadingLocales = useSelector(state => state.forms.loadingLocales);
  const loadingTaxis = useSelector(state => state.user.loading);
  const checkUniquenessCreate = useSelector(
    state => state.forms.checkUniquenessCreate
  );

  const [isSubmitModalVisible, setIsSubmitModalVisible] = useState(false);
  const [modalOutcome, setModalOutcome] = useState(null);

  const rejectAuditorReason = useSelector(
    state => state.forms?.carrier?.rejectAuditorReason
  );
  const rejectAuditorMessage = useSelector(
    state => state.forms?.carrier?.rejectAuditorMessage
  );

  const withdrawCommitteeReason = useSelector(
    state => state.forms?.carrier?.withdrawCommitteeReason
  );
  const withdrawCommitteeMessage = useSelector(
    state => state.forms?.carrier?.withdrawCommitteeMessage
  );

  useEffect(() => {
    const storedLanguage = localStorage.getItem('appLanguage');
    dispatch(getSystemLocales(storedLanguage));
    dispatch(checkUser(navigate));
    dispatch(getUser());
    dispatch(getTaxisData());
    dispatch(clearForm());
    const data = {
      page: currentPage,
      pageSize: pageSizeFlag,
      language: storedLanguage,
      sortData: {
        column: sortDirection ? sortColumn : '',
        direction: sortDirection ? (sortDirection === 'ascend' ? 'ASCENDING' : 'DESCENDING') : 'DESCENDING'
      },
      parameterList: []
    };
    dispatch(fetchProcInstancesDetailed(data));
    dispatch(getAllTaskNames());
  }, [dispatch, navigate]);

  useEffect(() => {
    if (user?.taxis_data?.afm && isBeneficiary(groups)) {
      handleCheckUniqueness({
        user,
        dispatch,
        checkUniqueness,
      }).then(res => {
        const reasons = {
          case: 'checkUniqueness',
          acceptable: res.acceptable,
          // responseCode: res.responseCode, //"901",//res.responseCode,
        };
        dispatch(
          updateFormField({
            group: 'checkUniquenessCreate',
            key: 'canCreate',
            value: res.acceptable,
          })
        );
      });
    }
  }, [user?.taxis_data?.afm]);

  const dateFormat = 'DD/MM/YYYY';
  const marks = {
    0: '0 €',
    2000: '2.000 €',
  };
  const handlePageChange = (page, pageSize) => {
    if (pageSize !== pageSizeFlag) {
      page = 1;
    }
    setCurrentPage(page);
    setPageSizeFlag(pageSize);
    const data = {
      page: page,
      pageSize: pageSize,
      language: localStorage.getItem('appLanguage'),
      sortData: {
        column: sortDirection ? sortColumn : '',
        direction: sortDirection ? (sortDirection === 'ascend' ? 'ASCENDING' : 'DESCENDING') : 'DESCENDING'
      },
      parameterList: detailedPayload?.parameterList
    };
    dispatch(fetchProcInstancesDetailed(data));
  };

  const handleTableChange = (pagination, filters, sorter, extra) => {
    const sortChanged = !!sorter.order || !!sortDirection ? sorter.columnKey !== sortColumn || sorter.order !== sortDirection : false;
    if (sortChanged) {
      setSortColumn(sorter.columnKey);
      setSortdirection(sorter.order);
      setCurrentPage(1);
      const data = {
        page: 1,
        pageSize: pageSizeFlag,
        language: localStorage.getItem('appLanguage'),
        sortData: {
          column: sorter.order ? sorter.columnKey : '',
          direction: sorter.order ? (sorter.order === 'ascend' ? 'ASCENDING' : 'DESCENDING') : 'DESCENDING'
        },
        parameterList: detailedPayload?.parameterList
      };
      dispatch(fetchProcInstancesDetailed(data));
    }
  };

  const renderTitle = title => <span>{title}</span>;

  const renderItem = title => ({
    value: title,
    label: (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {title}
      </div>
    ),
  });

  const toggleFilters = () => {
    setFiltersVisible(!isFiltersVisible);
    if (isFiltersVisible) {
      setFilterImg(<FilterIconBold />);
    } else {
      setFilterImg(<FilterIcon />);
    }
  };

  const overFilter = () => {
    setFilterImg(<FilterIconBold />);
  };

  const outFilter = () => {
    if (isFiltersVisible) {
      setFilterImg(<FilterIconBold />);
    } else {
      setFilterImg(<FilterIcon />);
    }
  };

  const cancelProcess = selectedProcId => {
    dispatch(cancelProcessInstance(selectedProcId));
    setCancelModal(false);
    window.location.reload();
  };

  const filterText = isFiltersVisible ? 'filterText' : 'filterTextDefault';

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: record => {
      return {
        disabled:
          record.applStatus !== 'AS_1G' && record.applStatus !== 'AS_6B',
      };
    },
  };

  // Open modal gia ton auditor
  const handleOpenSubmitModal = outcome => {
    setModalOutcome(outcome);
    setIsSubmitModalVisible(true);
  };

  // Add this function to handle the actual submission
  const handleModalSubmit = async () => {
    if (
      modalOutcome === auditorOutcomes.approveAuditor ||
      modalOutcome === auditorOutcomes.rejectAuditor
    ) {
      await handleAuditorSubmit({
        outcome: modalOutcome,
        dispatch,
        procInstId: selectedProcId,
        navigate,
        rejectAuditorReason,
        rejectAuditorMessage,
      });
      setIsSubmitModalVisible(false);
    }
    else if (
      modalOutcome === committeeOutcomes.finalApproveCommittee ||
      modalOutcome === committeeOutcomes.withdrawCommittee
    ) {
      await handleCommitteeSubmit({
        outcome: modalOutcome,
        dispatch,
        procInstId: selectedProcId,
        navigate,
        withdrawCommitteeReason,
        withdrawCommitteeMessage,
      });
      setIsSubmitModalVisible(false);
    }
  };

  useEffect(() => {
    if (!isEmpty(detailedPayload) && userStatus) {
      setCurrentPage(1);
      const data = {
        page: 1,
        pageSize: pageSizeFlag,
        language: localStorage.getItem('appLanguage'),
        sortData: {
          column: sortDirection ? sortColumn : '',
          direction: sortDirection ? (sortDirection === 'ascend' ? 'ASCENDING' : 'DESCENDING') : 'DESCENDING'
        },
        parameterList: detailedPayload?.parameterList
      };
      dispatch(fetchProcInstancesDetailed(data));
    }
  }, [detailedPayload]);

  const formatter = new Intl.NumberFormat('el-GR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });

  const saytOptionsTmp = [];

  const handleSAYT = value => {
    if (value.length >= 3) {
      dispatch(fetchProcessSAYT(value));
    }
  };

  useEffect(() => {
    if (sayt && !isEmpty(sayt)) {
      Object.values(sayt).map(key => {
        const opt = { options: [] };
        if (key?.name != 'limitExceeded') {
          if (key?.name == 'abiVat' || key?.name == 'legalVat') {
            opt.label = renderTitle('Α.Φ.Μ.');
          } else if (key?.name == 'businessKey') {
            opt.label = renderTitle('Αρ Αίτησης');
          } else if (key?.name == 'companyName') {
            opt.label = renderTitle('Επωνυμία');
          }
          const uniqueValues = new Set();

          for (let value of key?.values) {
            if (!uniqueValues.has(value.value)) {
              uniqueValues.add(value.value);
              opt.options.push(renderItem(value.value));
            }
          }
          saytOptionsTmp.push(opt);
        }
        setSaytOptions(saytOptionsTmp);
      });
    } else {
      setSaytOptions([]);
    }
  }, [sayt]);

  const prefix = <SearchIcon style={{ marginRight: '14px' }} />;

  const onSAYTSelect = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    // detailedPayloadTmp["saytKey"] = value;
    // setDetailedPayload(detailedPayloadTmp);
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('sayt'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'sayt') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'sayt',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSAYTSearch = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('sayt'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'sayt') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'sayt',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSAYTChange = value => {
    if (value.length == 0) {
      dispatch(clearSayt());
      setSaytOptions([]);
      const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
      // delete detailedPayloadTmp.saytKey;
      // setDetailedPayload(detailedPayloadTmp);
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onStatusChange = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    // console.log(detailedPayloadTmp, value)
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('activeTaskName'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'activeTaskName') {
            return { ...obj, value: [value] };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'activeTaskName',
          type: 'STRING_LIST',
          value: [value],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'activeTaskName'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onFilterChange = (value, qualifier, type) => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes(qualifier))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === qualifier) {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: qualifier,
          type: type,
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== qualifier
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onDateRangeChange = (value, dateString) => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (!isEmpty(dateString[0]) && !isEmpty(dateString[1])) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'submission_date') {
            return { ...obj, from: dateString[0], to: dateString[1] };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'submission_date',
          type: 'RANGE_DATE',
          from: dateString[0],
          to: dateString[1],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'submission_date'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSliderChange = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (!isEmpty(value[0]) && !isEmpty(value[1])) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'totalValue') {
            return { ...obj, from: value[0], to: value[1] };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'totalValue',
          type: 'RANGE_VALUE',
          from: value[0],
          to: value[1],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'totalValue'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const id = open ? 'simple-popover' : 'simple-popover';

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
  }, []);

  const onMoreClick = (id, b_key) => event => {
    setSelectedProcId(id);
    dispatch(setActiveFormId(id));
    // setSelectedBusinessKey(b_key);
    // setSelectedBusKey(b_key);
    setAnchorEl(event.currentTarget);
    setOpen(true);
    // setUsers([]);
    // setSelectedUser(null);
    // setAssignDisabled(false);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const getStatusTag = status => {
    switch (status) {
      case 'task.name.submit_application':
        return getLocalString(locales, localNames.TASK_NAME_SUBMIT_APPLICATION);
      //Αξιολόγηση Αίτησης
      case 'task.name.audit_application':
        return getLocalString(locales, localNames.TASK_NAME_AUDIT_APPLICATION);
      //Απόρριψη
      case 'task.name.application_rejection':
        return getLocalString(
          locales,
          localNames.TASK_NAME_APPLICATION_REJECTION
        );
      //Υποβολή Ένστασης
      case 'task.name.submit_objection':
        return getLocalString(locales, localNames.TASK_NAME_SUBMIT_OBJECTION);
      //Αξιολόγηση ΕΕ
      case 'task.name.ee_evaluation':
        return getLocalString(locales, localNames.TASK_NAME_EE_EVALUATION);
      //ακύρωση Αίτησης
      case 'task.name.cancelled_task':
        return getLocalString(locales, localNames.TASK_NAME_CANCELLED_TASK);
      //Προσωρινή Ένταξη
      case 'task.name.implementation_monitoring':
        return getLocalString(
          locales,
          localNames.TASK_NAME_IMPLEMENTATION_MONITORING
        );
      //Έναρξη Προγράμματος
      case 'task.name.implementation_monitoring_doc_submission':
        return getLocalString(
          locales,
          localNames.TASK_NAME_IMPLEMENTATION_MONITORING_DOC_SUBMISSION
        );
      //Απένταξη Αίτησης
      case 'task.name.application_withdrawal':
        return getLocalString(
          locales,
          localNames.TASK_NAME_APPLICATION_WITHDRAWAL
        );

      default:
        return null;
    }
  };

  const getProgram = schoolGrade => {
    if (
      schoolGrade?.includes('Νηπιαγωγείο') ||
      schoolGrade?.includes('Δημοτικό Σχολείο') ||
      schoolGrade?.includes('Αθηνά')
    )
      return 'Αθηνά';
    else if (!isNil(schoolGrade) || schoolGrade?.includes('Φοίβος'))
      return 'Φοίβος';
    else return '-';
  };

  const beneficiaryColumns = [
    {
      title: 'Αριθμός Αίτησης',
      dataIndex: 'businessKey',
      key: 'businessKey',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.businessKey}`}
            text={text}
          />
        );
      },
      sorter: true,
      sortOrder: sortColumn === 'businessKey' ? sortDirection : null,
      // width: 85,
      fixed: 'left',
    },
    {
      title: 'Πρόγραμμα',
      dataIndex: 'schoolGrade',
      key: 'schoolGrade',
      sorter: true /*{
        compare: (a, b) =>
          getProgram(a.schoolGrade) - getProgram(b.schoolGrade),
      },
      sorter: {
        compare: (a, b) => {
          // Check if both properties exist and are strings
          if (
            typeof getProgram(a.schoolGrade) === 'string' &&
            typeof getProgram(b.schoolGrade) === 'string'
          ) {
            return getProgram(a.schoolGrade).localeCompare(
              getProgram(b.schoolGrade)
            );
          }

          // Handle cases where one or both properties don't exist or aren't strings
          if (
            typeof getProgram(a.schoolGrade) !== 'string' &&
            typeof getProgram(b.schoolGrade) === 'string'
          ) {
            return -1; // a comes first if b has valid companyName but a doesn't
          }
          if (
            typeof getProgram(a.schoolGrade) === 'string' &&
            typeof getProgram(b.schoolGrade) !== 'string'
          ) {
            return 1; // b comes first if a has valid companyName but b doesn't
          }
          return 0; // If neither a nor b have valid companyName, treat them as equal
        },
      }*/,
      render: (text, record) => (
        <TableCell
          id={`abiVat-cell-${record.businessKey}`}
          text={getProgram(text)}
        />
      ),
      sortOrder: sortColumn === 'schoolGrade' ? sortDirection : null,
      // width: 255,
      // width: 71,
    },

    {
      title: 'Επωνυμία Δήμου',
      dataIndex: 'companyName',
      key: 'companyName',
      className: isBeneficiary(groups) ? 'hidden' : '',
      sorter: true/*{
        compare: (a, b) => {
          // Check if both properties exist and are strings
          if (
            typeof a.companyName === 'string' &&
            typeof b.companyName === 'string'
          ) {
            return a.companyName.localeCompare(b.companyName);
          }

          // Handle cases where one or both properties don't exist or aren't strings
          if (
            typeof a.companyName !== 'string' &&
            typeof b.companyName === 'string'
          ) {
            return -1; // a comes first if b has valid companyName but a doesn't
          }
          if (
            typeof a.companyName === 'string' &&
            typeof b.companyName !== 'string'
          ) {
            return 1; // b comes first if a has valid companyName but b doesn't
          }
          return 0; // If neither a nor b have valid companyName, treat them as equal
        },
      }*/,
      render: (text, record) => (
        <TableCell id={`abiVat-cell-${record.businessKey}`} text={text} />
      ),
      sortOrder: sortColumn === 'companyName' ? sortDirection : null,
      // width: 255,
      // width: 71,
    },
    {
      title: 'Status',
      dataIndex: 'activeTaskName',
      key: 'activeTaskName',
      render: (text, record) => {
        return (
          <StatusTag
            id={`activeTaskName-cell-${record.businessKey}`}
            status={text}
          />
        );
      },
      sorter: true/*{
        compare: (a, b) => {
          // Check if both properties exist and are strings
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return getStatusTag(a.activeTaskName).localeCompare(
              getStatusTag(b.activeTaskName)
            );
          }

          // Handle cases where one or both properties don't exist or aren't strings
          if (
            typeof getStatusTag(a.activeTaskName) !== 'string' &&
            typeof getStatusTag(b.activeTaskName) === 'string'
          ) {
            return -1; // a comes first if b has valid activeTaskName but a doesn't
          }
          if (
            typeof getStatusTag(a.activeTaskName) === 'string' &&
            typeof getStatusTag(b.activeTaskName) !== 'string'
          ) {
            return 1; // b comes first if a has valid activeTaskName but b doesn't
          }
          return 0; // If neither a nor b have valid activeTaskName, treat them as equal
        },
      }*/,
      sortOrder: sortColumn === 'activeTaskName' ? sortDirection : null,
      // width: 255,
      // className: "col-2",
    },
    {
      title: 'Επωνυμία Σχολείου',
      dataIndex: 'buildName',
      key: 'buildName',
      render: (text, record) => {
        return (
          <TableCell
            id={`companyName-cell-${record.businessKey}`}
            text={text}
          />
        );
      },
      sorter: true/*{
        compare: (a, b) => {
          // Check if both properties exist and are strings
          if (
            typeof a.buildName === 'string' &&
            typeof b.buildName === 'string'
          ) {
            return a.buildName.localeCompare(b.buildName);
          }

          // Handle cases where one or both properties don't exist or aren't strings
          if (
            typeof a.buildName !== 'string' &&
            typeof b.buildName === 'string'
          ) {
            return -1; // a comes first if b has valid companyName but a doesn't
          }
          if (
            typeof a.buildName === 'string' &&
            typeof b.buildName !== 'string'
          ) {
            return 1; // b comes first if a has valid companyName but b doesn't
          }
          return 0; // If neither a nor b have valid companyName, treat them as equal
        },
      }*/,
      sortOrder: sortColumn === 'buildName' ? sortDirection : null,
      // width: 255,
      // className: "col-3",
      // width: 260,
    },

    {
      title: 'Μείωση % Πρωτογενούς Ενέργειας',
      key: 'nrgDifference',
      dataIndex: 'nrgDifference',
      // dataIndex: "Co2Difference", //Lefteris comment: This should be conditionaly shown later but we dont have all the implementation details yet (30/11/2023).
      // className:  "col-7",
      sorter: false/*{
        compare: (a, b) => {
          // Check if both properties exist and are numbers
          if (
            typeof a.nrgDifference === 'number' &&
            typeof b.nrgDifference === 'number'
          ) {
            return a.nrgDifference - b.nrgDifference;
          }

          // Handle cases where one or both properties don't exist or aren't numbers
          if (
            typeof a.nrgDifference !== 'number' &&
            typeof b.nrgDifference === 'number'
          ) {
            return -1; // a comes first if b has valid Co2Difference but a doesn't
          }

          if (
            typeof a.nrgDifference === 'number' &&
            typeof b.nrgDifference !== 'number'
          ) {
            return 1; // b comes first if a has valid Co2Difference but b doesn't
          }

          return 0; // If neither a nor b have valid Co2Difference, treat them as equal
        },
      }*/,
      render: text => <TableCell text={text} />,
      sortOrder: sortColumn === 'nrgDifference' ? sortDirection : null,
      // width: 70,
    },

    {
      title: 'Υποβολή',
      dataIndex: 'submissionDate',
      key: 'submissionDate',
      render: (text, record) => {
        return (
          <TableCell
            id={`submissionDate-cell-${record.businessKey}`}
            text={getFullDateTimeWithSeconds(text)}
          />
        );
      },
      sorter: true/*{
        compare: (a, b) => {
          if (a.submissionDate && b.submissionDate) {
            return new Date(a.submissionDate) - new Date(b.submissionDate);
          } else if (!a.submissionDate && b.submissionDate) {
            return -1;
          } else if (a.submissionDate && !b.submissionDate) {
            return 1;
          } else {
            return 0;
          }
        },
      }*/,
      sortOrder: sortColumn === 'submissionDate' ? sortDirection : null,
      // width: 255,
    },
    {
      title: 'Βαθμοημέρες',
      dataIndex: 'degDays',
      key: 'degDays',
      className: isBeneficiary(groups) ? 'hidden' : '',
      sorter: false/*{
        compare: (a, b) => a.degDays - b.degDays,
      }*/,
      render: (text, record) => (
        <TableCell id={`abiVat-cell-${record.businessKey}`} text={text} />
      ),
      sortOrder: sortColumn === 'degDays' ? sortDirection : null,
      // width: 255,
      // width: 71,
    },
    {
      title: 'Έγκριση',
      key: 'auditorApprovalDate',
      sorter: true/*(a, b) =>
        moment(a.auditorApprovalDate).unix() - moment(b.auditorApprovalDate).unix()*/,
      // className:  "col-4" ,
      dataIndex: 'approvalDate',
      render: date => getFullDateTime(date),
      sortOrder: sortColumn === 'auditorApprovalDate' ? sortDirection : null,
      //width: 120,
    },

    {
      title: '',
      fixed: 'right',
      key: 'action',
      align: 'right',
      render: (text, record) => {
        return (
          <Space
            id={`action-cell-${record.businessKey}`}
            align="end"
            style={{ width: 'auto', marginRight: '2rem' }}
          >
            <Tooltip title="Actions">
              <ActionsIcon
                aria-describedby={id}
                onClick={e => onMoreClick(record.id, record.businessKey)(e)}
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  const [sortedUp, setSortedUp] = useState(false);
  const [sortedDown, setSortedDown] = useState(true);

  return loadingTaxis || loadingLocales ? (
    <div
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
      }}
    >
      <Spin size="large" />
    </div>
  ) : (
    <main>
      <Modal
        id={`cancel-modal-${selectedProcId}`}
        centered
        width={400}
        open={cancelModal}
        className={`custom-modal`}
        onCancel={() => setCancelModal(false)}
        onOk={() => setCancelModal(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          <h3>Επιβεβαίωση Ακύρωσης Αίτησης</h3>
          <p>
            Είστε σίγουροι ότι επιθυμείτε να ακυρώσετε την συγκεκριμένη αίτηση;
          </p>
          <p>Προσοχή η ενέργεια είναι μη αναστρέψιμη.</p>
        </div>
        <div className="footerBtnContainer">
          <div
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setCancelModal(false)}
          >
            Επιστροφή
          </div>
          <div
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => cancelProcess(selectedProcId)}
            className="btn-assign"
          >
            Επιβεβαίωση
          </div>
        </div>
      </Modal>

      <div>
        <div>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          >
            <ActionList
              open={setOpen}
              id={selectedProcId}
              payload={detailedPayload}
              setCancelModal={setCancelModal}
              onOpenSubmitModal={handleOpenSubmitModal}
            />
          </Popover>
        </div>

        {/* Negative margin as a temp fix to avoid altering layout for other pages as well */}
        <div style={{ marginTop: '-24px' }}>
          {/* <div style={{ marginTop: "30px", marginBottom: "21px" }}> */}
          {privileges?.includes('CanRenderSAYT') && !isBeneficiary(groups) && (
            <div>
              <AutoComplete
                popupClassName="certain-category-search-dropdown"
                dropdownMatchSelectWidth={500}
                style={{ width: '100%' }}
                options={saytOptions}
                onSearch={handleSAYT}
                onSelect={onSAYTSelect}
                onChange={onSAYTChange}
                defaultValue={detailedPayload?.saytKey}
              >
                <Input.Search
                  id="autocomplete-search-input"
                  onSearch={onSAYTSearch}
                  bordered={false}
                  allowClear={true}
                  prefix={prefix}
                  className="sayt-input-filter input-filter"
                  size="large"
                  // placeholder={getLocalString(
                  //   locales,
                  //   isKTP ? localNames.HOME_PAGE_SEARCHKTP :
                  //   isBeneficiary(groups) ? localNames.HOME_PAGE_SEARCHNP :
                  //   ''
                  // )}
                  placeholder={
                    isBeneficiary(groups)
                      ? 'Αναζήτηση με Αρ. Αίτησης, Α.Φ.Μ., Σχολείο'
                      : 'Αναζήτηση με Αρ. Αίτησης, Α.Φ.Μ., Επωνυμία Δήμου, Επωνυμία Σχολείου'
                  }
                  enterButton
                />
              </AutoComplete>
            </div>
          )}

          {privileges?.includes('CanRenderAppFilters') &&
            !isBeneficiary(groups) && (
              <div className="mt-2">
                <Tooltip placement="right" title="Expanded Filters">
                  <Space
                    id="filters-toggle-button"
                    onClick={() => toggleFilters()}
                    onMouseEnter={() => overFilter()}
                    onMouseLeave={() => outFilter()}
                    className="filterButton"
                  >
                    {filterImg}
                    <span className={filterText}>
                      {getLocalString(
                        locales,
                        localNames.HOME_PAGE_FILTERSBUTTON
                      )}
                    </span>
                  </Space>
                </Tooltip>

                {isFiltersVisible && (
                  <div className="filtersContainer">
                    <div className="filters-wrapper">
                      <div style={{ flex: '1' }}>
                        <Select
                          id="select-application-status"
                          suffixIcon={<ArrowIcon />}
                          className="input-filter"
                          style={{ width: '100%' }}
                          dropdownAlign={{ offset: [-11, 5] }}
                          showSearch
                          allowClear={true}
                          placeholder={
                            getLocalString(
                              locales,
                              localNames?.HOME_PAGE_FILTERS_STATUS
                            ) || 'Status'
                          }
                          optionFilterProp="children"
                          onChange={onStatusChange}
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {taskNames?.map(item => (
                            <Option
                              id={`status-${item.name}-option`}
                              key={item.name}
                              value={item.name}
                            >
                              {getLocalString(locales, item.name)}
                            </Option>
                          ))}
                        </Select>
                      </div>

                      <div style={{ flex: '1' }}>
                        <RangePicker
                          id="application-results-date-range-picker-from"
                          locale={{
                            ...locale,
                            lang: {
                              ...locale.lang,
                              rangePlaceholder: [
                                getLocalString(
                                  locales,
                                  localNames.HOME_PAGE_FILTERS_DATEFROM
                                ),
                                getLocalString(
                                  locales,
                                  localNames.HOME_PAGE_FILTERS_DATETO
                                ),
                              ],
                            },
                          }}
                          format={dateFormat}
                          suffixIcon={<CalendarIcon />}
                          allowEmpty={[true, true]}
                          onCalendarChange={onDateRangeChange}
                          className="input-filter"
                          style={{ width: '100%', height: 'unset !important' }}
                        />
                      </div>
                      {!isBeneficiary(groups) ? (
                        <div style={{ flex: '1' }}>
                          <Select
                            suffixIcon={<ArrowIcon />}
                            className="input-filter"
                            style={{ width: '100%' }}
                            dropdownAlign={{ offset: [-11, 5] }}
                            showSearch
                            allowClear={true}
                            placeholder="Βαθμίδα Σχολείου"
                            optionFilterProp="children"
                            defaultValue={detailedPayload.schoolGrades}
                            onChange={e =>
                              onFilterChange(e, 'schoolGrade', 'STRING_VALUE')
                            }
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {schoolGrades.map(i => {
                              return <Option value={i.label}>{i.value}</Option>;
                            })}
                          </Select>
                        </div>
                      ) : (
                        <div style={{ flex: '1' }} />
                      )}
                    </div>
                    {!isBeneficiary(groups) && (
                      <div className="filters-wrapper">
                        {/* <div style={{ flex: "1" }}>
                        <Select
                          suffixIcon={<ArrowIcon />}
                          className="input-filter"
                          style={{ width: "100%" }}
                          dropdownAlign={{ offset: [-11, 5] }}
                          showSearch
                          allowClear={true}
                          placeholder="ΚΑΔ"
                          optionFilterProp="children"
                          defaultValue={detailedPayload.mainΚad}
                          onChange={(e) => onFilterChange(e, "mainKad", "STRING_VALUE")}
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {kadArray.map((i) => {
                            return (
                              <Option value={i.label}>
                                {i.label + " - " + i.value}
                              </Option>
                            );
                          })}
                        </Select>
                      </div> */}
                        {/* <div style={{ flex: "1" }}>
                        <Select
                          suffixIcon={<ArrowIcon />}
                          className="input-filter"
                          style={{ width: "100%" }}
                          dropdownAlign={{ offset: [-11, 5] }}
                          showSearch
                          allowClear={true}
                          placeholder="Αξιολόγηση"
                          optionFilterProp="children"
                          defaultValue={detailedPayload.auditEvaluation}
                          onChange={(e) => onFilterChange(e, "auditEvaluation", "BOOLEAN_VALUE")}
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          <Option value="true">Έγκριση</Option>
                          <Option value="false">Απόρριψη</Option>
                        </Select>
                      </div> */}
                        <div style={{ flex: '1' }}></div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

          {isBeneficiary(groups) && (
            <Alert
              className="beneficiary-banner"
              message="Ενημέρωση για Υποβολή Αιτήσεων"
              description={
                <div>
                  Η υποβολή αιτήσεων στο Πρόγραμμα ολοκληρώθηκε στις 15 Μαΐου
                  2025 σύμφωνα με σχετική ανακοίνωση του Υπουργείου
                  Περιβάλλοντος και Ενέργειας (
                  <a
                    href="https://ypen.gov.gr/paratasi-ypovolis-aitiseon-gia-ta-programmata-foivos-kai-athina-pou-aforoun-energeiaki-anavathmisi-se-dimotika-scholeia-nipiagogeia-kai-paidikous-stathmous/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Παράταση υποβολής αιτήσεων για τα Προγράμματα «Φοίβος» και
                    «Αθηνά», που αφορούν ενεργειακή αναβάθμιση σε Δημοτικά
                    Σχολεία, Νηπιαγωγεία και Παιδικούς Σταθμούς - Υπουργείο
                    Περιβάλλοντος και Ενέργειας
                  </a>
                  )
                </div>
              }
              type="info"
              showIcon
              style={{ marginBottom: 16 }}
              closable={false}
            />
          )}
          <Divider className="filter-divider" />
          {loadingPage && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin
                id="apptrack-application-results-table-spinner"
                size="default"
              />
            </div>
          )}
          {!loadingPage && (
            <Row gutter={32}>
              <Col span={24}>
                {!isEmpty(results) &&
                  (!isBeneficiary(groups) ||
                    (isBeneficiary(groups) &&
                      checkUniquenessCreate?.canCreate)) && (
                    <div>
                      <Table
                        scroll={{ x: true }}
                        id="apptrack-application-results-table"
                        className="results-table"
                        dataSource={results}
                        columns={beneficiaryColumns}
                        rowKey="id"
                        pagination={{
                          total: resultSize,
                          current: currentPage,
                          showSizeChanger: true,
                          pageSizeOptions: [5, 10, 20, 50, 100, 200],
                          showTitle: false,
                          pageSize: pageSizeFlag,
                          onChange: handlePageChange,
                        }}
                        onChange={handleTableChange}
                      />
                    </div>
                  )}

                {isEmpty(results) &&
                  (!isBeneficiary(groups) ||
                    (isBeneficiary(groups) &&
                      checkUniquenessCreate?.canCreate)) && (
                    <NoResults
                      id="apptrack-application-results-no-results"
                      description={'Δε βρέθηκαν αποτελέσματα'}
                      subDescription={''}
                    />
                  )}
                {isSubmitModalVisible && (
                  <SubmitModal
                    isVisible={isSubmitModalVisible}
                    setIsVisible={setIsSubmitModalVisible}
                    handleSubmit={handleModalSubmit}
                    submitDisabled={false}
                    formKey="auditor"
                    outcome={modalOutcome}
                    businessKey={selectedProcId}
                  />
                )}

                {isBeneficiary(groups) &&
                  !isNil(checkUniquenessCreate) &&
                  !checkUniquenessCreate?.canCreate && (
                    <NoResults
                      id="apptrack-application-results-no-results"
                      description={
                        <div>
                          <p>Δεν έχετε τη δυνατότητα να υποβάλετε αίτηση.</p>
                        </div>
                      }
                      subDescription={''}
                    />
                  )}
              </Col>
            </Row>
          )}
        </div>
      </div>
    </main>
  );
};

export default AppTrackPage1;